// const React = require('react')
// const Layout = require('./src/components/Layout')

import React from 'react'
import Provider from './src/components/Provider'
import { ThemeProvider } from './src/components/ThemeContext'
// import Layout from './src/components/Layout'

export const wrapRootElement = ({ element }) => (
    <>
     {/* <Layout {...props}> */}
        <Provider>
            <ThemeProvider>
                {element}
            </ThemeProvider>
        </Provider>
    {/* </Layout> */}
    </>
  );
